import { ApiError } from '@gorila-shared-ui/components';
import { ApiEndpoint } from '../types/api';
import { Event, EventAlarmType, EventTimeLineCore } from '../types/gpt';
import { fileRequest, getRequest } from './api';
import { URLS } from './urls';

export const getGptEvent = async (eventId: string): Promise<{ event?: Event; error?: ApiError }> => {
  const response = await getRequest(
    URLS.monitoring.public.safeGptEvent.detail(eventId),
    undefined,
    undefined,
    ApiEndpoint.monitoring,
  );
  return {
    event: response?.data,
    error: response?.error,
  };
};

export const getEventAlarmEvidenceUrl = async (key: string): Promise<{ url?: string; error?: ApiError }> => {
  const response = await fileRequest(key);
  return {
    url: response?.data?.url,
    error: response?.error,
  };
};

export const getEventAlarmTypes = async (): Promise<{ alarmTypes?: EventAlarmType[]; error?: ApiError }> => {
  const response = await getRequest(URLS.core.gpt.alarm.types, undefined, undefined, ApiEndpoint.core);
  return {
    alarmTypes: response?.data,
    error: response?.error,
  };
};

export const getEventTimeline = async (
  eventId: string,
): Promise<{ timeLineEvents?: EventTimeLineCore[]; error?: ApiError }> => {
  const response = await getRequest(
    URLS.monitoring.public.safeGptEvent.timeline(eventId),
    undefined,
    undefined,
    ApiEndpoint.monitoring,
  );
  return {
    timeLineEvents: response?.data?.items,
    error: response?.error,
  };
};
